module.exports = __webpack_public_path__ + "static/media/moons_advanced-1500.df26da0f.jpg";